import React from 'react'
import Header from '../layouts/Header'
import Footer from '../layouts/Footer'
import CareersHero from '../layouts/Careers/CareersHero'
import WhyWorkWithUs from '../layouts/Careers/WhyWorkWithUs'
import LifeAtAppVerse from '../layouts/Careers/LifeAtAppVerse'
import OpenPositions from '../layouts/Careers/OpenPositions'
import HiringProcess from '../layouts/Careers/HiringProcess'
import PerksBenefits from '../layouts/Careers/PerksBenefits'
import FinalCTA from '../layouts/FinalCTA'

const Careers = () => {
    return (
        <>
            <Header />
            <CareersHero />
            <WhyWorkWithUs/>
            <OpenPositions/>
            <HiringProcess/>
            <PerksBenefits/>
            <FinalCTA/>
            <Footer />

        </>
    )
}

export default Careers